// extracted by mini-css-extract-plugin
export default {"wrap":"ls-z","melodyCategory":"ms-z","fullWidth":"ns-z","items":"os-z","featureCss":"ps-z","disabled":"qs-z","imgCss":"rs-z"};